import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { borderColor, darkGrayFontColor, destructive } from '../../../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	surveyForm: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 24,
		margin: '16px auto',
		width: '100%',
		maxWidth: 600,
	},
	formControl: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		width: '100%',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	formControlFullWidth: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		width: '100%',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	label: {
		fontSize: 14,
		fontWeight: 600,
		color: darkGrayFontColor,
		textAlign: 'left',
	},
	optionalLabel: {
		fontSize: 11,
	},
	textInput: {
		width: '100%',
		padding: 10,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
	},
	textArea: {
		width: '100%',
		minHeight: 96,
		padding: 10,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		resize: 'vertical',
		fontFamily: 'inherit',
		fontSize: 14,
	},
	// Standalone masked phone input — match the `.text-input` chrome (gray fill, border, radius)
	// since, unlike the birthday field, there is no calendar button beside it.
	maskedInput: {
		height: 'auto',
		padding: 10,
		fontSize: THEME.typography.fontSizes.sm,
		boxShadow: 'none',
		background: THEME.colors.background.main,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
	},
	// The `.text-input` shell is already `display:flex; align-items:center`; just space the
	// masked input from the calendar icon.
	birthdayField: {
		gap: THEME.spacing.sm,
	},
	// Strip the components-v2 Input chrome so the MaskedInput blends into the `.text-input` shell.
	birthdayMaskInput: {
		flexGrow: 1,
		width: 'auto',
		minWidth: 0,
		background: 'transparent',
		border: 'none',
		borderRadius: 0,
		padding: 0,
		height: 'auto',
		boxShadow: 'none',
		fontSize: THEME.typography.fontSizes.sm,
		':focus': {
			outline: 'none',
			boxShadow: 'none',
		},
	},
	birthdayCalendarButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
		background: 'transparent',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		color: darkGrayFontColor,
		borderRadius: THEME.common.borderRadius,
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: 2,
		},
	},
	selectTrigger: {
		width: '100%',
	},
	checkboxRow: {
		textAlign: 'left',
		marginBottom: 4,
	},
	errorMessage: {
		color: destructive,
		fontSize: 12,
		marginTop: 4,
		textAlign: 'left',
	},
	noMargin: {
		margin: 0,
	},
	divider: {
		height: 1,
		background: borderColor,
		margin: '24px 0',
		width: '100%',
	},
	actions: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	introContent: {
		fontSize: 14,
		maxWidth: 600,
		margin: '12px auto',
		textAlign: 'left',
	},
	loadingLogo: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
	},
	countrySelector: {
		width: '100%',
		...CssSelectors.allDescendants(
			{
				width: '100%',
			},
			'.select-box'
		),
	},
	addressSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		textAlign: 'left',
	},
	addressHeader: {
		fontWeight: 600,
		fontSize: 16,
		marginBottom: 16,
		color: darkGrayFontColor,
		margin: 0,
	},
	addressFieldRow: {
		display: 'flex',
		gap: 16,
		width: '100%',
		'@media (max-width: 768px)': {
			flexDirection: 'column',
			gap: 12,
		},
	},
	addressColumn: {
		flex: 1,
	},
	countrySelectorContainer: {
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'div'
		),
	},
});
